import { render, staticRenderFns } from "./FlagshipGoalsWizardPersonalGoal.vue?vue&type=template&id=4520cc48&scoped=true&"
import script from "./FlagshipGoalsWizardPersonalGoal.vue?vue&type=script&lang=ts&"
export * from "./FlagshipGoalsWizardPersonalGoal.vue?vue&type=script&lang=ts&"
import style0 from "./FlagshipGoalsWizardPersonalGoal.vue?vue&type=style&index=0&id=4520cc48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520cc48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCol,VContainer,VImg,VRow,VTextField})
